import "./LeaderboardItem.css";

function LeaderBoardItem(props) {

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return(
        <>
        <div className="leaderboard-item">
            <span className="rank">{props.data.rank}.</span>
            <span className="name">{props.data.userPlatformName}</span>
            <span className="score">{numberWithCommas(props.data.score)}</span>
        </div>
        </>
    )

}

export default LeaderBoardItem;